export default __webpack_public_path__ + "static/media/logo6.0347e92c.webp";